import React, { useMemo } from "react";
import {
  Autocomplete,
  TextField,
  Typography,
  Box,
  createFilterOptions,
} from "@mui/material";
import {
  buildValidParentOptions,
  findParentOption,
  getParentOptionLabel,
  isFlowStartSlot,
} from "./chatbotSlotParentUtils";

const filterOptions = createFilterOptions({
  limit: 80,
  stringify: (option) => [option.searchText, option.label, option.path].filter(Boolean).join(" "),
});

export default function ChatbotParentSlotPicker({
  slot,
  allSlots = [],
  value,
  onChange,
  disabled = false,
}) {
  const isStart = isFlowStartSlot(slot, allSlots);

  const options = useMemo(
    () => buildValidParentOptions(slot, allSlots),
    [slot, allSlots]
  );

  const selected = useMemo(
    () => findParentOption(options, value),
    [options, value]
  );

  if (isStart) {
    return (
      <TextField
        label="Passo pai"
        size="small"
        fullWidth
        disabled
        value="Raiz do fluxo"
        helperText="O passo inicial é a raiz do chatbot e não pode ser movido."
        variant="outlined"
      />
    );
  }

  return (
    <Autocomplete
      size="small"
      fullWidth
      disabled={disabled}
      options={options}
      value={selected}
      onChange={(_, option) => onChange(option ? Number(option.value) : 0)}
      getOptionLabel={getParentOptionLabel}
      isOptionEqualToValue={(a, b) => Number(a?.value) === Number(b?.value)}
      filterOptions={filterOptions}
      noOptionsText="Nenhum passo pai disponível"
      renderInput={(params) => (
        <TextField
          {...params}
          label="Passo pai"
          placeholder="Busque o passo que será o pai deste nó"
          helperText="Move este passo para outro ponto do fluxo. Não é possível escolher a si mesmo, subpassos ou slots de Exceção."
          variant="outlined"
        />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.value}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2">{option.label}</Typography>
            {option.path ? (
              <Typography variant="caption" color="text.secondary" noWrap>
                {option.path}
                {option.value ? ` · #${option.value}` : ""}
              </Typography>
            ) : null}
          </Box>
        </Box>
      )}
      ListboxProps={{ sx: { maxHeight: 280 } }}
    />
  );
}
